import { Component, Inject, Input, LOCALE_ID, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { formatDate } from '@angular/common';
import { FlyoutDataType } from '../flyout-models';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-flyout-time-overview',
  templateUrl: './flyout-time-overview.component.html',
  styleUrls: ['./flyout-time-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutTimeOverviewComponent implements OnInit {
  private _firstVisit: string;
  private _latestVisit: string;
  private _flyoutDataType: FlyoutDataType;
  public _secondsOnSite: number;
  public FlyoutDataTypes = FlyoutDataType;
  public firstVisitString: string;
  public latestVisitString: string;
  public firstVisitTimestamp: string;
  public firstVisitTimestampNumber: number;
  public latestVisitTimestamp: string;

  @Input() public set flyoutDataType(flyoutDataType: FlyoutDataType) {
    this._flyoutDataType = flyoutDataType;
    this.formatStrings();
  }
  public get flyoutDataType(): FlyoutDataType {
    return this._flyoutDataType;
  }

  @Input() public set secondsOnSite(secondsOnSite: number) {
    this._secondsOnSite = secondsOnSite;
    this.formatStrings();
  }
  public get secondsOnSite(): number {
    return this._secondsOnSite;
  }

  @Input() public set firstVisit(firstVisit: string) {
    this._firstVisit = firstVisit;
    this.formatStrings();
  }

  public get firstVisit(): string {
    return this._firstVisit;
  }

  @Input() public set latestVisit(latestVisit: string) {
    this._latestVisit = latestVisit;
    this.formatStrings();
  }

  public get latestVisit(): string {
    return this._latestVisit;
  }

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {}

  private formatStrings() {
    if (this._flyoutDataType) {
      if (this._firstVisit) {
        this.firstVisitString = this.getFormatedDateString(this._firstVisit);
        this.firstVisitTimestamp = this.getTimestampString(this._firstVisit);
        this.firstVisitTimestampNumber = this.getTimestampAsNumber(this._firstVisit);
      }
      if (this._latestVisit) {
        this.latestVisitString = this.getFormatedDateString(this._latestVisit);
        this.latestVisitTimestamp = this.getTimestampString(this._latestVisit);
      }
    }
  }

  private getTimestampString(date: string) {
    if (!date) {
      return undefined;
    }
    const dateStringFormat = 'yyyy-MM-dd HH:mm:ss';
    const dateConverted = new Date(date);
    const localDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
    localDate.setUTCMilliseconds(dateConverted.getTime());
    return formatDate(localDate, dateStringFormat, this.locale);
  }

  private getTimestampAsNumber(date: string) {
    if (!date) {
      return undefined;
    }
    const utcDateConverted = new Date(date);
    const localDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
    localDate.setUTCMilliseconds(utcDateConverted.getTime());
    return localDate.getTime();
  }

  private getFormatedDateString(date: string) {
    if (!date) {
      return undefined;
    }
    const utcDateConverted = new Date(date);
    const now = new Date().getTime();
    const localDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
    localDate.setUTCMilliseconds(utcDateConverted.getTime());
    const sinceNow = Math.round((now - localDate.getTime()) / 60000);
    let sinceString = '';
    if (sinceNow < 60) {
      sinceString = sinceNow + ' ' + this.translateService.instant('dateRange.minutesAgo');
    } else if (sinceNow < 60 * 24) {
      sinceString = Math.round(sinceNow / 60) + ' ' + this.translateService.instant('dateRange.hoursAgo');
    } else if (sinceNow < 60 * 24 * 60) {
      sinceString = Math.round(sinceNow / 60 / 24) + ' ' + this.translateService.instant('dateRange.daysAgo');
    } else {
      sinceString = Math.round(sinceNow / 60 / 24 / 7) + ' ' + this.translateService.instant('dateRange.weeksAgo');
    }
    return sinceString; // + ' - ' + formatDate(retrievalDate, dateStringFormat, this.locale);
  }
}
